module.exports = __webpack_public_path__ + "static/besa-1ac3147a7bb275aebe3cb4e41bbf4c99.png";